module.exports = __webpack_public_path__ + "static/media/favorite.da74443f.svg";